export const styles = {
  container: {
    backgroundColor: '#EEEEEE',
    height: '480px',
  },
  collapse: {
    display: 'flex',
    overflow: 'hidden',
    flexBasis: '50em',
    transition: 'flex-basis 0.3s ease-out',
    borderRadius: '2px',
  },
  field: {
    overflow: 'hidden',
    //padding: '16px 0px',
    backgroundColor: '#FAFAFA',
    width: '100%',
  },
  content: {
    overflow: 'auto',
    height: '100%',
    //padding: '0px 16px',
    padding: '16px 16px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#3E3E3E',
  },
  scrollBar: {
    '*::-webkit-scrollbar': {
      width: '12px',
      height: '12px',
    },
    '*::-webkit-scrollbar-track:vertical': {},
    '*::-webkit-scrollbar-track:horizontal': {},
    '*::-webkit-scrollbar-track-piece:end': {
      //marginBottom: '-16px',
    },
    '*::-webkit-scrollbar-track-piece:start': {
      //marginTop: '-16px',
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#BDBDBD',
      border: '2px solid transparent',
      borderRadius: '4px/4px',
      backgroundClip: 'content-box',
    },
    '*::-webkit-scrollbar-corner': {},
  },
  pre: {
    display: 'block',
    unicodeBidi: 'embed',
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  },
  loading: {
    backgroundColor: '#FAFAFA',
    width: '100%',
    height: '480px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '400',
    color: '#3E3E3E',
  },
  toggleButtonsGroup: {
    backgroundColor: '#eeeeee',
    width: '100%',
    maxHeight: '44px',
    marginTop: '2px',
    fontSize: '14px',
    fontWeight: '500',
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      border: 0,
      borderRadius: '4px 4px 0px 0px !important',
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#FAFAFA',
        color: '#009FDA',
      },
    },
  },
}
